import ReactTooltip from 'react-tooltip';
import cn from 'classnames';
import React from 'react';
import {createUseStyles} from 'react-jss';

type TooltipProps = {
  content: React.ReactNode
  label: string
  className?: string
}

/**
 * Tooltip (usually wit the icon)
 * @param content {string} Tooltip's content
 * @param label {string} Label
 * @param className {string} Additional classes for the tooltip's target
 * @param children {ReactElement} Tooltip's target
 * @constructor
 */
export default function Tooltip({
  content, label, className, children,
}: React.PropsWithChildren<TooltipProps>) {
  const styles = createUseStyles({
    padding: {
      padding: '12px !important',
      borderRadius: '10px !important',
      lineHeight: '1.5 !important',
    },
  })();

  return (
    <>
      <a data-tip data-for={label} className={cn('cursor-pointer', className)}>
        {children}
      </a>
      <ReactTooltip id={label} effect="solid" class={cn('font-normal rounded-xl', styles.padding)}>{content}</ReactTooltip>
    </>
  );
}
